import Image from "next/image";

const ContentHeader = ({ heading, subHeading }) => {
  return (
    <>
      <div className="absolute -z-10">
        <img
          src={"/images/contact-us-bg.webp"}
          width={1080}
          height={1080}
          className="relative -top-20 right-0 -z-10 w-screen h-[280px] "
          alt="zysoftec services"
          fetchPriority="high"
        />
      </div>
      <div className="absolute -z-10 w-full flex float-right top-[190%] lg:top-[55%]">
        <Image
          className="h-[200px] w-[200px] md:h-[300px] md:w-[300px] opacity-30 relative -z-10 -right-[40%] lg:-right-[77%] "
          src={"/images/contact-us-circle.webp"}
          width={1080}
          height={1080}
          alt="zysoftec services"
        />
      </div>
      <div className="text-[#16349F] text-3xl lg:text-4xl grid px-8 lg:px-16 font-bold py-8 relative z-20  mt-10">
        <div className="flex justify-between">
          <Image
            className="h-[30px] w-[30px] md:h-[40px] md:w-[40px] "
            src={"/images/contact-us-circle.webp"}
            alt="zysoftec services"
            width={1080}
            height={1080}
          />
          <div className="grid text-center">
            <p className={`text-lg md:text-3xl`}>
              {heading}
            </p>
            <span
              className={`text-sm text-black font-medium mt-2`}
            >
              {subHeading}
            </span>
          </div>
          <Image
            className="h-[30px] w-[30px] md:h-[40px] md:w-[40px]"
            src={"/images/contact-us-circle.webp"}
            alt="zysoftec services"
            width={1080}
            height={1080}
          />
        </div>
        <div className="flex justify-center gap-[30%]">
          <span className="h-[6px] w-[6px] md:h-[10px] md:w-[10px] rounded-full bg-[#1A3183]"></span>
          <span className="h-[6px] w-[6px] md:h-[10px] md:w-[10px] rounded-full bg-[#FA7070] ml-20 mt-4"></span>
        </div>
      </div>
    </>
  );
};

export default ContentHeader;
